import { useEffect } from "react"
import { TournamentClient } from "@/domain/tournament/client/TournamentClient"
import {
  makeInitTournamentDetailState,
  TournamentDetailStore,
} from "@/domain/tournament/store/TournamentDetailStore"

/**
 * 대회 단건 훅.
 * 홈 화면과 참가 신청 화면이 같은 대회 정보를 공유하므로 Store 에 둔다.
 */
export function useTournamentDetail(id: string) {
  function useTournamentDetailState() {
    return TournamentDetailStore.useStore()
  }

  async function fetchDetail() {
    // 대회를 고르지 않은 화면(신청 폼 직접 진입)은 조회할 것이 없다
    if (!id) {
      TournamentDetailStore.set("isLoaded", true)
      return
    }

    try {
      const detail = await TournamentClient.getById(id)
      TournamentDetailStore.set("detail", detail)
      TournamentDetailStore.set("errorMessage", "")
    } catch (error) {
      TournamentDetailStore.set("detail", null)
      TournamentDetailStore.set(
        "errorMessage",
        error instanceof Error
          ? error.message
          : "대회 정보를 불러오지 못했습니다.",
      )
    } finally {
      TournamentDetailStore.set("isLoaded", true)
    }
  }

  useEffect(() => {
    TournamentDetailStore.store.setState(makeInitTournamentDetailState())
    void fetchDetail()

    return () => {
      TournamentDetailStore.store.setState(makeInitTournamentDetailState())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return { useTournamentDetailState }
}
